import { all, call, put, takeLatest, select } from "redux-saga/effects";
import {
  APPLICANT_INFO_FORM,
  applicantInfoFormFail,
  applicantInfoFormSuccess
} from "../actions/applicantInfoForm";
import {
  updateProspectId,
  updateProspect,
  updateExistingCustomer,
  updateSubSource,
  updateScreeningResults
} from "../actions/appConfig";
import { resetInputsErrors, setInputsErrors } from "./../actions/serverValidation";
import { generateCodeSuccess } from "../actions/otp";
import { prospect as prospectApi } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import {
  getApplicationInfo,
  getAuthorizationHeader,
  getProspect,
  getLeadSource
} from "./../selectors/appConfig";
import { FieldsValidationError } from "../../api/serverErrors";
import { NEXT, SAVE, SUB_SOURCE, COMPANY } from "../../constants";

export function* applicantInfoFormSaga({ payload }) {
  try {
    //const isRecaptchaEnable = yield select(getIsRecaptchaEnable);
    const prospect = yield select(getProspect);
    const applicationInfo = yield select(getApplicationInfo);
    const { headers } = yield select(getAuthorizationHeader);
    const leadSource = yield select(getLeadSource);
    headers["stage-id"] = "createProspect";

    // payload.LeadSource = leadSource;
    const prospectUpdated = {
      ...prospect,
      applicantInfo: {
        LeadSource: leadSource,
        allianceCode: payload.allianceCode !== undefined ? payload.allianceCode : "",
        countryCode: payload.countryCode,
        declaration: false,
        email: payload.email,
        emailType: COMPANY,
        fullName: payload.fullName,
        mobileNo: payload.mobileNo,
        mobileNoType: COMPANY,
        roCode: payload.roCode
      },
      applicationInfo: {
        ...applicationInfo,
        existingCustomer: false,
        saveType: NEXT,
        actionType: SAVE
      },
      organizationInfo: {
        ...prospect.organizationInfo,
        contactDetails: {
          ...prospect.organizationInfo.contactDetails,
          primaryEmail: payload.email,
          primaryMobileNo: payload.mobileNo,
          primaryMobileCountryCode: payload.countryCode,
          primaryPhoneCountryCode: payload.countryCode
        }
      }
    };

    yield put(updateProspect({ prospect: prospectUpdated }));

    const sendingData = { ...prospectUpdated };

    /**if (isRecaptchaEnable) {
      sendingData.recaptchaToken = yield select(getReCaptchaToken);
    }**/

    const {
      data: { prospectId, existingCustomer, preScreening, validRoCode }
    } = yield call(prospectApi.create, sendingData, { headers });

    yield put(generateCodeSuccess());
    yield put(updateProspectId(prospectId));
    if (preScreening) {
      yield put(updateScreeningResults(preScreening));
    }
    yield put(resetInputsErrors());
    yield put(updateExistingCustomer(existingCustomer));
    if (validRoCode === "Y") {
      yield put(updateSubSource(SUB_SOURCE.RMApply));
    }
    yield put(applicantInfoFormSuccess({ existingCustomer, validRoCode }));
  } catch (error) {
    if (error instanceof FieldsValidationError) {
      yield put(setInputsErrors(error.getInputsErrors()));
    } else {
      log(error);
    }
    yield put(applicantInfoFormFail(error));
  }
}

export default function* applicantInfoSaga() {
  yield all([takeLatest(APPLICANT_INFO_FORM, applicantInfoFormSaga)]);
}
